import React, { useState, useRef } from 'react';

import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { FaBarcode, FaQrcode } from 'react-icons/fa';
import { AxiosInstance } from 'axios';
import { useModal } from '../../../../../../hooks/Modal';

import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';

import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import Button from '../../Forms/Button';

import { usePrinter } from '../../../../../../hooks/PrinterHook';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import api from '../../../../../../services/api';
import { decodeCracha } from '../Cracha';
import { string } from 'yup';


interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef?: AxiosInstance;
}

export default function useCrachaLoteAgendamento()  {
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { addPrint, printIt } = usePrinter();
  const { configuration } = useConfiguration();
  const key = uuid();



  const print = async (line) => {

  await api.put(`/visitation-calendar-subscriptions/${line?._id}/impresso`, { impresso: 'Sim'} );
    printIt();





  };

  const getLastName = (last_name) => {

    if (!last_name) {
      return last_name || '';
    }

    if (configuration?.theme_data?.cracha_split_last_name === "yes") {

      const index = last_name.indexOf(' ');

      if (index >= 0) {
        const splits = last_name.split(" ");
        const length = splits.length - 1;
        return splits?.[length] || '';
      }
      else {
        return last_name;
      }

    }
    else {

      return last_name;
    }


  }


  const handleQR = async ({lineData}): Promise<void> => {


    const line =   await api.get(`/visitation-calendar-subscriptions/${lineData?._id}` );



    let html: Array<JSX.Element> = [];
   const professor = await api.get(`/students/${lineData?.client_id_response?._id}` );

    const data = await api.get('/students', { params: { limitItems: 10000, where: { project_id: configuration?.url, visitation_hash : lineData?.hash }, order: { orderBy: 'name', direction: 'asc' } } });

    const dataRows = data?.data?.rows || [];
    if(professor?.data?.inscricao_2 !== "Sim"){
        html.push(<>  <div className="qrHolder2" style={{ display: 'flex', width: '100%', minWidth: '8.7cm', justifyContent: 'space-between', alignItems: 'center', padding: '15px', paddingBottom: '0px', paddingTop: configuration?.theme_data?.cracha_margin_top_line ? configuration?.theme_data?.cracha_margin_top_line : '0px' }}>

          <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingRight: '20px' }}>
            {decodeCracha(professor?.data, configuration?.cracha_config)}
          </div>
          {configuration?.cracha_have_qrcode !== 'no' && professor?.data?.user_hash ? <div style={{ width: '80px', minWidth: '80px' }}><QRCode
            size={80}
            value={professor?.data.user_hash} renderAs="svg" /></div> : <></>}

        </div><div className="breakPage" /></>);
    }


    if (dataRows) {
      dataRows?.map((line, index) => {
   if(line?.name && line?.inscricao_2 !== 'Sim'){
        html.push(<>  <div className="qrHolder2" style={{ display: 'flex', width: '100%', minWidth: '8.7cm', justifyContent: 'space-between', alignItems: 'center', padding: '15px', paddingBottom: '0px', paddingTop: configuration?.theme_data?.cracha_margin_top_line ? configuration?.theme_data?.cracha_margin_top_line : '0px' }}>

          <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingRight: '20px' }}>
            {decodeCracha(line, configuration?.cracha_config)}
          </div>
          {configuration?.cracha_have_qrcode !== 'no' && line?.user_hash ? <div style={{ width: '80px', minWidth: '80px' }}><QRCode
            size={80}
            value={line.user_hash} renderAs="svg" /></div> : <></>}

        </div><div className="breakPage" /></>);
   }
      });

    }


    addPrint(
      html
    );


    const content = <div className='column gap-xs'><h2 style={{ color: '#fff' }}>CRACHÁ</h2><Button onClick={() => print(line?.data)}>Imprimir</Button>
    {line?.data?.impresso === 'Sim' ? <p style={{width: '100%', background: 'red', color:'#fff', padding: '10px'}}>Lote já impresso</p> : <></>}
    <p style={{width: '100%', padding: '10px', textAlign:'center'}}> ({data.data?.rows?.filter( i => i?.name)?.length})com nome | ({data.data?.rows?.filter( i => !i?.name)?.length})sem nome</p>
 {professor?.data?.inscricao_2 === "Sim" ?  <p style={{width: '100%', color: 'red', padding: '10px', textAlign:'center'}}> Professor já impresso</p>
 : <></>}

 <p style={{width: '100%', padding: '10px', textAlign:'center'}}> ({data.data?.rows?.filter( i => i?.inscricao_2 === 'Sim')?.length}) alunos já impressos</p>
 

    <div style={{ background: '#fff', width: '9cm', textAlign: 'center' }}>{html}</div> </div>;

    if (content) {
      const keyModal = addModal({ title: 'Imprimir Lote', theme:'whiteModalMini', content, key });
    }



  };
 
return {handleQR}
 
}
